var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLauncherIconDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 77,
    viewBox: "0 0 80 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_7230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2 17.363C18.8272 10.9064 24.2541 5.9812 30.7411 5.9812H52.8938C58.4811 5.9812 63.4011 9.66066 64.9802 15.0201L78.3833 60.5081C80.7615 68.5796 74.7114 76.6696 66.2968 76.6696H26.3221C18.8817 76.6696 13.0615 70.2565 13.7809 62.851L18.2 17.363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6228 17.363C12.2501 10.9064 17.677 5.9812 24.164 5.9812H52.9417C59.0115 5.9812 64.2187 10.3087 65.3292 16.2761L73.7943 61.7641C75.2364 69.5136 69.2893 76.6696 61.4068 76.6696H19.7449C12.3046 76.6696 6.48434 70.2565 7.20377 62.851L11.6228 17.363Z",
    fill: "#019D66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.03195 17.4062C5.65504 10.9458 11.0836 6.01562 17.5739 6.01562H52.7611C59.3544 6.01562 64.8328 11.0985 65.326 17.6733L68.7606 63.4572C69.3089 70.767 63.5259 77 56.1957 77H13.1581C5.72125 77 -0.0978394 70.5927 0.616127 63.1901L5.03195 17.4062Z",
    fill: "#21E09D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9757 52.7444L20.1123 41.6298L24.2554 37.4033L30.9757 44.2749L45.0193 29.9066L49.1624 34.1455L30.9757 52.7444Z",
    fill: "#1F529D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.8534,
    cy: 14.5456,
    rx: 3.8368,
    ry: 3.8063,
    fill: "#1F529D"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 46.4218,
    cy: 14.5456,
    rx: 3.8368,
    ry: 3.8063,
    fill: "#1F529D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6942 6.05177C25.8304 7.88636 24.4977 10.7152 24.4977 14.6814C24.4977 15.5823 23.7615 16.3127 22.8533 16.3127C21.9452 16.3127 21.209 15.5823 21.209 14.6814C21.209 9.94754 22.8224 6.2513 25.3778 3.73584C27.9168 1.23656 31.2889 -1.5557e-06 34.6378 0C37.9867 1.42606e-06 41.3588 1.23657 43.8978 3.73585C46.4532 6.25131 48.0666 9.94755 48.0666 14.6814C48.0666 15.5824 47.3304 16.3127 46.4223 16.3127C45.5141 16.3127 44.7779 15.5824 44.7779 14.6814C44.7779 10.7152 43.4452 7.88637 41.5814 6.05177C39.7012 4.201 37.1811 3.26254 34.6378 3.26254C32.0944 3.26254 29.5743 4.201 27.6942 6.05177Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_7230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 79,
    height: 77,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLauncherIconDark);
export default __webpack_public_path__ + "static/media/launcherIcon_dark.85644a1173ae772f54f135839cade8b9.svg";
export { ForwardRef as ReactComponent };